import axios from "axios"

import { API_URL } from "../../config/appConfig"

export const DOCUMENT_BASE_URL = `${API_URL}/api/IssuerDocument`

export const getPendingDocuments = (headers: any) => {
  return axios.get(`${DOCUMENT_BASE_URL}/pending`, { headers })
}

export const getPendingDocumentsForIssuer = (issuerId: number, headers: any) => {
  return axios.get(`${DOCUMENT_BASE_URL}/issuer/${issuerId}`, { headers })
}

export const getIssuerDocumentFile = (documentId: string, onDownloadProgress: any) => {
  return axios.get(`${DOCUMENT_BASE_URL}/download/${documentId}`, { responseType: "blob", onDownloadProgress })
}

export const postIssuerDocument = (payload: any) => {
  const formData = new FormData()
  Object.keys(payload).forEach((key: string) => formData.append(key, payload[key]))
  return axios.post(DOCUMENT_BASE_URL, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    },
    maxBodyLength: 10000000,
    maxContentLength: 10000000
  })
}

export const putIssuerDocument = (payload: any) => {
  return axios.put(`${DOCUMENT_BASE_URL}/update`, payload)
}

export const deleteDocument = (documentId: string) => {
  return axios.delete(`${DOCUMENT_BASE_URL}/${documentId}`)
}

export const patchIssuerDocumentStatus = (documentId : string, params : any) => {
  return axios.patch(`${DOCUMENT_BASE_URL}/${documentId}`,{},{ params })
}
